module.exports = __webpack_public_path__ + "img/banner.da63e881.png";